export default "__VITE_ASSET__CLXFfhrs__"